// Configuração do ambiente, lida de window.AULRA_CONFIG (public/config.js, gerado no deploy).
// Só a chave publicável do Supabase; a chave secreta nunca entra no site.
export interface SiteConfig {
  supabaseUrl: string;
  supabasePublishableKey: string;
  translationHttpUrl: string;
  translationWsUrl: string;
  listenBaseUrl: string;
  /** Site key do Cloudflare Turnstile; ausente ou vazia, o CAPTCHA fica desligado (src/captcha.ts). */
  turnstileSiteKey?: string;
}

const FIELDS: (keyof SiteConfig)[] = [
  "supabaseUrl",
  "supabasePublishableKey",
  "translationHttpUrl",
  "translationWsUrl",
  "listenBaseUrl",
];

export function config(): SiteConfig {
  const raw = (globalThis as { AULRA_CONFIG?: Partial<SiteConfig> }).AULRA_CONFIG;
  if (!raw) throw new Error("config.js ausente: copie public/config.example.js para public/config.js");
  for (const f of FIELDS) {
    if (typeof raw[f] !== "string" || raw[f] === "") throw new Error(`config.js: campo ${f} ausente`);
  }
  return raw as SiteConfig;
}
